import { render, staticRenderFns } from "./ModalClient.vue?vue&type=template&id=6435df82&"
import script from "./ModalClient.vue?vue&type=script&lang=js&"
export * from "./ModalClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports